import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentTrackingPage() {
  return (
    <LatamAgentPage locale="pt-BR" agentKey="tracking_and_status_updates" />
  );
}
